// v1 course images live under /public/<imageName>. v2 courses (Create v5 /
// Content Pipeline) store images under an originals/ path served from
// /images/<imageName-with-resized>, so /public/ 404s for those. Render the
// /public/ path first and swap to the /images/ resized path on error.
export let coursePublicImageSrc = (imageName: string | undefined) =>
  `${import.meta.env.VITE_CLOUDFRONT_URL}/public/${imageName}`

export let courseResizedImageSrc = (imageName: string | undefined) =>
  `${import.meta.env.VITE_CLOUDFRONT_URL}/images/${imageName?.replace('originals', 'resized')}`

export let onCourseImageError = (
  event: React.SyntheticEvent<HTMLElement, Event>,
  imageName: string | undefined,
) => {
  if (!imageName) return

  let target = event.currentTarget as HTMLImageElement
  let fallback = courseResizedImageSrc(imageName)
  if (target.src !== fallback) {
    // eslint-disable-next-line fp/no-mutation
    target.src = fallback
  }
}

// Same v1/v2 split as above, but for callers that want to render the
// resized path first (v2) and fall back to the public path (v1) on error.
export let onCourseImagePublicFallback = (
  event: React.SyntheticEvent<HTMLElement, Event>,
  imageName: string | undefined,
) => {
  if (!imageName) return

  let target = event.currentTarget as HTMLImageElement
  let fallback = coursePublicImageSrc(imageName)
  if (target.src !== fallback) {
    // eslint-disable-next-line fp/no-mutation
    target.src = fallback
  }
}
